/* Kishi Kaisei : barre d'achat collante, mobile uniquement.
   ------------------------------------------------------------------
   Les fiches produit sont longues (caracteristiques, bundle, avis, FAQ).
   Une fois le visiteur descendu, le bouton d'achat n'est plus a l'ecran
   et rien ne l'y ramene. Cette barre apparait des que le bouton d'origine
   est passe au-dessus du champ de vision, et se retire quand il revient.

   Elle ne remplace pas le bouton du theme : elle clique dessus. Toute la
   logique du theme (ajout au panier, tiroir, compteur) reste donc la seule
   source de verite, et rien ne casse si le formulaire evolue.

   Choix technique : on mesure la position au defilement, sans passer par
   IntersectionObserver ni requestAnimationFrame. Les deux sont suspendus
   quand l'onglet n'est pas au premier plan, ce qui rend le comportement
   invisible aux outils de verification. Une lecture de position par
   evenement de defilement coute peu, et l'ecriture dans le DOM n'a lieu
   qu'au changement d'etat, pas a chaque pixel parcouru.

   Deux details voulus :
   - la pastille de l'assistant Microsoft est en bas a gauche. Quand la
     barre s'affiche, on la remonte pour qu'elles ne se recouvrent pas.
   - le bas d'ecran des iPhone recents mord sur le contenu, d'ou le
     safe-area-inset-bottom.
*/
(function () {
  'use strict';

  var LARGEUR_MAX = 749;   /* au-dela, le bouton reste atteignable, barre inutile */
  var HAUTEUR = 68;

  if (!document.body.classList.contains('template-product')) { return; }

  function demarrer() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) { return; }
    var bouton = form.querySelector('button[type="submit"], [name="add"]');
    var titre = document.querySelector('h1');
    if (!bouton || !titre) { return; }

    /* Rupture de stock : pas de barre, le message du theme suffit. */
    if (bouton.disabled) { return; }

    var style = document.createElement('style');
    style.textContent =
      '.kk-atc{position:fixed;left:0;right:0;bottom:0;z-index:60;display:flex;' +
      'align-items:center;gap:12px;padding:10px 14px;' +
      'padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));' +
      'background:var(--ink,#1c1a17);border-top:1px solid var(--line,rgba(255,255,255,.14));' +
      'transform:translateY(110%);transition:transform .28s cubic-bezier(.22,1,.36,1);' +
      'visibility:hidden}' +
      '.kk-atc.is-on{transform:translateY(0);visibility:visible}' +
      '.kk-atc__txt{flex:1 1 auto;min-width:0;line-height:1.25}' +
      '.kk-atc__nom{display:block;font-size:12.5px;color:var(--paper-dim,#c3c4bc);' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.kk-atc__prix{display:block;font-size:15px;font-weight:700;color:var(--paper,#f0ede8)}' +
      '.kk-atc__btn{flex:0 0 auto;background:var(--btn-bg,#5f6d55);color:var(--btn-fg,#fff);' +
      'border:0;border-radius:var(--btn-radius,2px);padding:13px 20px;font:inherit;' +
      'font-size:13.5px;font-weight:700;letter-spacing:.04em;cursor:pointer}' +
      '.kk-atc__btn:focus-visible{outline:2px solid var(--paper,#f0ede8);outline-offset:2px}' +
      '@media (min-width:' + (LARGEUR_MAX + 1) + 'px){.kk-atc{display:none}}' +
      '@media (prefers-reduced-motion:reduce){.kk-atc{transition:none}}';
    document.head.appendChild(style);

    var barre = document.createElement('div');
    barre.className = 'kk-atc';
    barre.setAttribute('aria-hidden', 'true');

    var txt = document.createElement('span');
    txt.className = 'kk-atc__txt';

    var nom = document.createElement('span');
    nom.className = 'kk-atc__nom';
    nom.textContent = titre.textContent.trim();

    var prix = document.createElement('span');
    prix.className = 'kk-atc__prix';
    var sourcePrix = document.querySelector('.price-item');
    prix.textContent = sourcePrix ? sourcePrix.textContent.trim() : '';

    txt.appendChild(nom);
    txt.appendChild(prix);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kk-atc__btn';
    btn.textContent = 'Ajouter au panier';
    btn.addEventListener('click', function () { bouton.click(); });

    barre.appendChild(txt);
    barre.appendChild(btn);
    document.body.appendChild(barre);

    /* La pastille de l'assistant vit dans un shadow DOM ferme au CSS de la
       page : on la deplace donc en JS, et seulement tant que la barre est la. */
    function bougerPastille(active) {
      var hote = document.getElementById('ads-agent-host');
      if (!hote || !hote.shadowRoot) { return; }
      var pastilles = hote.shadowRoot.querySelectorAll('[data-testid="entrypoint"]');
      for (var i = 0; i < pastilles.length; i++) {
        if (active) {
          pastilles[i].style.setProperty('bottom', HAUTEUR + 22 + 'px', 'important');
        } else {
          pastilles[i].style.removeProperty('bottom');
        }
      }
    }

    var affichee = false;
    function afficher(oui) {
      if (oui === affichee) { return; }
      affichee = oui;
      barre.classList.toggle('is-on', oui);
      barre.setAttribute('aria-hidden', oui ? 'false' : 'true');
      bougerPastille(oui);
    }

    /* La barre sert quand le vrai bouton est passe au-dessus du champ de
       vision. Tant qu'il est simplement plus bas dans la page, on ne montre
       rien : le visiteur n'a pas encore eu l'occasion de l'utiliser. */
    function mesurer() {
      if (window.innerWidth > LARGEUR_MAX) { afficher(false); return; }
      afficher(bouton.getBoundingClientRect().bottom < 0);
    }

    window.addEventListener('scroll', mesurer, { passive: true });
    window.addEventListener('resize', mesurer);
    mesurer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
